export const resources = {
  GalleryDeleteVideoMassage: '',
  Delete: '',
  Cancel: ''
};
